import { z } from 'zod/v4';

import { createLegacyEntitySchema } from '@sites/entity-migrator';

import { imageLegacyDefaultV0Schema } from './default';
import { imageLegacyZeroV0Schema } from './zero';

/**
 * Discriminated union over the envelope's `type` field. Persisted entities
 * without a `type` field land on the default branch (its `type` literal is
 * `.optional()`); entities tagged `type: 'zero'` land on the zero branch.
 *
 * Like button, the two image variants diverge on the inner data shape: the
 * default branch carries the simple `position` grid (nullish), the zero branch
 * requires the extended-position grid plus the `imagePosition` keyword.
 */
const imageLegacyEntityUnion = z.discriminatedUnion('type', [imageLegacyDefaultV0Schema, imageLegacyZeroV0Schema]);

export type LegacyImageDefault = z.infer<typeof imageLegacyDefaultV0Schema>;
export type LegacyImageZero = z.infer<typeof imageLegacyZeroV0Schema>;
export type LegacyImage = LegacyImageDefault | LegacyImageZero;

/**
 * Legacy-only entity: the persisted widget shape is the only version (no v0 yet).
 * Single 'web' variant today; the mini-landing shape becomes a second variant when
 * the widget is unified across apps. When a redesigned `default/v0` lands, this
 * switches to a versioned schema and the variants gain `up` migrations into it.
 */
export const LegacyImageEntitySchema = createLegacyEntitySchema([{ name: 'web', schema: imageLegacyEntityUnion }]);
